/**
 * Per-platform OAuth setup copy: what a user has to do in each ad platform's
 * own console before the connect form can succeed.
 *
 * Data, not behaviour — and it changes for reasons that have nothing to do with
 * the modal (a platform renames a screen, a scope changes). Out here it can be
 * corrected without opening a 750-line component.
 */

import type { PlatformType } from '@/types';

// OAuth instructions per platform
export const oauthInstructions: Record<
  PlatformType,
  {
    /** Keys, not sentences: this table is module scope, so a t() call here
     *  would resolve once at import and hold that language for the session. */
    steps: string[];
    helpUrl?: string;
  }
> = {
  facebook: {
    steps: [
      "settings.stepFb1",
      "settings.stepFb2",
      "settings.stepFb3",
    ],
    helpUrl: "https://developers.facebook.com/docs/marketing-api/overview/authorization/",
  },
  google_ads: {
    steps: [
      "settings.stepOauthRedirect",
      "settings.stepGrantGoogleAds",
      "settings.stepOauthReturn",
    ],
    helpUrl: "https://developers.google.com/google-ads/api/docs/first-call/overview",
  },
  tiktok: {
    steps: [
      "settings.stepOauthRedirectTikTok",
      "settings.stepGrantTikTok",
      "settings.stepOauthReturn",
    ],
    helpUrl: "https://ads.tiktok.com/marketing_api/docs?id=1738587022722049",
  },
  line: {
    steps: [
      "settings.stepLine1",
      "settings.stepLine2",
      "settings.stepLine3",
    ],
    helpUrl: "https://developers.line.biz/en/docs/line-ads-platform-api/overview/",
  },
  google_analytics: {
    steps: [
      "settings.stepOauthRedirect",
      "settings.stepGrantGa",
      "settings.stepOauthReturn",
    ],
    helpUrl: "https://developers.google.com/analytics/devguides/reporting/data/v1",
  },
};
